import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import SelectOptions from "./SelectOptions";

// use localSelectedBook data to make select options
// have local state for data changes coming from select
// set setLocalSelectedBook with local selected state on next step btn
const SelectSearchOptions = ({
  localSelectedBook,
  setLocalSelectedBook,
  handleBackStep,
  handleFinishStep,
  setSelectedBook,
}) => {
  const [selectedOptions, setSelectedOptions] = useState({
    ISBN: "",
    issued: { "date-parts": [[]] },
    "place-publisher": "",
    "publisher-place": "",
    publisher: "",
  });

  const handleSelectChange = (property, value) => {
    let updatedValue;

    if (property === "issued") {
      updatedValue = { "date-parts": [[value]] };
    } else if (property === "publisher-place") {
      // update both "publisher-place" and "place-publisher" with the same value
      updatedValue = value;
      setSelectedOptions({
        ...selectedOptions,
        "publisher-place": value,
        "place-publisher": value,
      });
      return; // Exit early to avoid updating "publisher-place" again
    } else {
      updatedValue = value;
    }

    // Update the selectedOptions with the property and its value
    setSelectedOptions({
      ...selectedOptions,
      [property]: updatedValue,
    });
  };
  console.log("localSelectedBook:", localSelectedBook);
  console.log("selectedOptions:", selectedOptions);

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        mt: "1rem",
      }}
      onSubmit={(e) => {
        e.preventDefault();
        setSelectedBook(() => ({
          ...localSelectedBook,
          ...selectedOptions,
        }));
        setLocalSelectedBook(null);
        handleFinishStep();
      }}>
      <SelectOptions
        label="ISBN"
        id="isbn"
        value={selectedOptions.ISBN || ""}
        onChange={(e) => handleSelectChange("ISBN", e.target.value)}
        options={localSelectedBook?.ISBN || []}
      />{" "}
      <SelectOptions
        label="Issued"
        id="issued"
        value={selectedOptions.issued["date-parts"][0][0] || ""}
        onChange={(e) => handleSelectChange("issued", e.target.value)}
        options={localSelectedBook?.issued["date-parts"][0][0] || []}
      />
      <SelectOptions
        label="Publisher Place"
        id="publisher-place"
        value={selectedOptions["publisher-place"] || ""}
        onChange={(e) => handleSelectChange("publisher-place", e.target.value)}
        options={localSelectedBook["publisher-place"] || []}
      />
      <SelectOptions
        label="Publisher"
        id="publisher"
        value={selectedOptions.publisher || ""}
        onChange={(e) => handleSelectChange("publisher", e.target.value)}
        options={localSelectedBook.publisher || []}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          pt: 2,
          justifyContent: "flex-end",
        }}>
        <Button color="inherit" onClick={handleBackStep} sx={{ mr: 1 }}>
          Back
        </Button>

        <Button type="submit">Finish</Button>
      </Box>
    </form>
  );
};

export default SelectSearchOptions;
